import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, ButtonState, ButtonVariant, Group, GroupGutter } from '@as/cotopaxi';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { ETICKET_CONSTANTS } from '../../../containers/EticketContainer';
export const EticketRatingButtons = ({ rateItem, rating }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    const isMobile = useMediaQueryMatchesOnMobile();
    const [voted, setVoted] = useState();
    const rateDivision = (rate) => {
        rateItem(rate);
        setVoted(rate);
    };
    const getButtonVariant = (ratingValue) => rating === ratingValue && !voted ? ButtonVariant.BRANDED : ButtonVariant.BASE;
    const ETICKET_BUTTONS = [
        {
            ratingValue: ETICKET_CONSTANTS.RATING.GOOD,
            text: t('eticket.rating.good'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.OK,
            text: t('eticket.rating.okay'),
        },
        {
            ratingValue: ETICKET_CONSTANTS.RATING.BAD,
            text: t('eticket.rating.bad'),
        },
    ];
    return (_jsx(Group, { gutter: GroupGutter.MEDIUM, column: isMobile, children: ETICKET_BUTTONS.map(({ ratingValue, text }) => (_jsx(Button, { onClick: () => rateDivision(ratingValue), text: text, variant: getButtonVariant(ratingValue), state: voted ? ButtonState.FINISHED : ButtonState.INTERACTIVE, finisher: voted === ratingValue ? { text } : undefined }, ratingValue))) }));
};
